let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fuwWn")).then(() => parcelRequire('cRloE'));